import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { IHttpRequestable, TimeMeasure } from ".";

export class HttpClient implements IHttpRequestable {
  constructor(logger: (m: string) => void = TimeMeasure.debug) {
    this._logger = logger
      ? logger
      : TimeMeasure.off;
  }
  
  private readonly _logger?: (m: string) => void;

  async get<T = any>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return TimeMeasure.logAsync(
      "GET: " + url + " ",
      async () => {
        return axios.get(url, config);
      },
      (config && config.params) ? HttpClient.paramsToString(config.params) : null,
      this._logger
    );
    return null;
  }
  
  async post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return TimeMeasure.logAsync(
      "POST: " + url + " ",
      async () => {
        return axios.post(url, data, config);
      },
      (config && config.params) ? HttpClient.paramsToString(config.params) : null,
      this._logger
    );
  }

  private static paramsToString(params: any): string {
    return Object.keys(params).map((key: string) => key + "=" + params[key]).join("&");
  }
}
